const app = {
	product_info: "产品信息",
	txid: "区块链记录: ",
	show_info: "更多信息",
	track_info: "流转信息",
	meterial_info: "溯源信息",
	product_head: "产品信息",
	show_head: "更多信息",
	track_head: "流转信息",
	meterial_head: "溯源信息",
	valid_msg: "此产品部分信息已被DNV认证",
	message_tc_landingpage_NotAllowException: "请联系管理员公开此信息",
	message_tc_landingpage_DataEmptyException: "芯片验真失败",
	message_default: "无法读取产品信息",
	sorry: "抱歉",
	download_msg: "建议使用VeChain Pro查看芯片验真及产品完整信息",
	download: "下载App",
	mainnet: "正试",
	testnet: "沙盒",
	mintText: '一物一码数字藏品',
	simpleText: '芯片未验证',
	track_info_multi: '个追溯记录',
	track_info_single: '个追溯记录',
	meterial_info_multi: '个溯源记录',
	meterial_info_single: '个溯源记录',
	custom_records_multi: '个记录',
	custom_records_single: '个记录',
	verify: {
		sku: "商品信息验证",
		chip: "芯片防伪验证",
		pass: "已通过",
		fail: "失败",
		view: "查看展示页",
		user: "请联系商家进行人工核查"
	},
	nft: {
		series: '系列',
		createTime: '创建时间',
		owner: '所有者',
		blockinfo: '上链信息',
		contractAddress: '合约地址'
	},
	block: {
		title: "区块链存证",
		header: "区块链记录",
		blockId: "区块ID",
		blockNumber: "所在区块",
		timestamp:"成块时间",
		txId:"交易编号",
		status: "上链状态"
	}
}

export default {
	app
}
